import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { Router } from '@angular/router';
import { VideoCallService } from 'src/providers/videocall';
import { AddCall } from 'src/providers/addvCall';
@Component({
  selector: 'app-vcalert',
  templateUrl: './vcalert.page.html',
  styleUrls: ['./vcalert.page.scss'],
})
export class VcalertPage implements OnInit {
  //vcURL: any;
  meetingid: any;
  password: any;
  name: any;
  constructor(private videocall: VideoCallService,
    public addCall: AddCall, 
    private router: Router, 
    private androidPermissions: AndroidPermissions, 
    public modalCtrl: ModalController) { }

  ngOnInit() {
  }

  decline() {
    this.modalCtrl.dismiss();
  }

  start() {
    this.modalCtrl.dismiss();
    this.videocall.startVideoCall(this.meetingid, this.password, this.name);
    /*this.androidPermissions.requestPermissions([this.androidPermissions.PERMISSION.CAMERA, this.androidPermissions.PERMISSION.RECORD_AUDIO, this.androidPermissions.PERMISSION.MODIFY_AUDIO_SETTINGS]).then(data=>{
      console.log(data);
      //this.bservice.openBrowser(this.vcURL);
      this.router.navigate(['menu/videocall']);
    });*/

    //this.router.()


  }

}




